import { NgModule } from '@angular/core';
import { AlphaNumericValidatorDirective } from './alphanumeric-validator.directive';
import { CnpjValidatorDirective } from './cnpj-validator.directive';
import { CpfValidatorDirective } from './cpf-validator.directive';
import { PropNameValidatorDirective } from './propName-validator-directive';
import { DecimalValidatorDirective } from './decimal-validator.directive';
import { IntegerValidatorDirective } from './integer-validator.directive';
import { UrlValidatorDirective } from './url-validator.directive';
import { AlphaValidatorDirective } from './alpha-validator.directive';

@NgModule({
  imports: [],
  declarations: [
    AlphaNumericValidatorDirective,
    CnpjValidatorDirective,
    CpfValidatorDirective,
    PropNameValidatorDirective,
    AlphaValidatorDirective,
    DecimalValidatorDirective,
    IntegerValidatorDirective,
    UrlValidatorDirective
  ],
  exports: [
    AlphaNumericValidatorDirective,
    CnpjValidatorDirective,
    CpfValidatorDirective,
    PropNameValidatorDirective,
    AlphaValidatorDirective,
    DecimalValidatorDirective,
    IntegerValidatorDirective,
    UrlValidatorDirective
  ]
})
export class AngularValidateBrLibModule { }
